import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Reveal } from './Reveal';

const badges = [
  'Single-tenant',
  'Client-owned',
  'HIPAA + SOC',
  'RADV-defensible',
];

export function TrustStrip() {
  return (
    <section className="py-14 bg-[#1f2937]">
      <Reveal className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex flex-wrap items-center justify-center gap-8">
          {badges.map((badge) => (
            <span key={badge} className="text-[#F4F7F9] font-medium whitespace-nowrap">
              {badge}
            </span>
          ))}
        </div>
        <Link
          to="/healthbridge#trust"
          className="inline-flex items-center gap-1 text-[#34AFFB] hover:text-[#70D6C5] font-medium whitespace-nowrap transition-colors"
        >
          See HealthBridge trust &amp; security
          <ArrowRight className="h-4 w-4" />
        </Link>
      </Reveal>
    </section>
  );
}
